import { constants, getTrackingEventToNavItem, links } from 'common/helpers'
import { createSelector } from 'reselect'
import messages from './messages'

import getAuthNav from './getAuthNav'


const getNoAuthNav = ({ globals }) => {
  const { isGiftsHidden } = globals

  return [
    { title: messages.womenMainPage,    dataTestId: 'womenMainPage',    toOLD: links.home },
    { title: messages.menMainPage,      dataTestId: 'menMainPage',      toOLD: links.homeMen },
    { title: messages.shopPerfumes,     dataTestId: 'shopPerfumes',     to: links.subscription.mainWomen },
    { title: messages.shopColognes,     dataTestId: 'shopColognes',     to: links.subscription.mainMen },
    ...(
      !isGiftsHidden ? [
        { title: messages.giftSetsMen,      dataTestId: 'giftSetsMen',      to: links.giftSetsMen },
        { title: messages.giftSetsWomen,    dataTestId: 'giftSetsWomen',    to: links.giftSet },
      ] : []
    ),
    { title: messages.skincareSets,     dataTestId: 'skincareSets',     to: links.skincareSets },
    { title: messages.giftSubscription, dataTestId: 'giftSubscription', to: links.gift },
    { title: messages.referAFriend,     dataTestId: 'referAFriend',     to: links.invite },
    { title: messages.register,         dataTestId: 'register',         to: links.register },
  ]
}

const createEvent = (item, subMenu) => getTrackingEventToNavItem(item, {
  snowplowEvent: subMenu
    ? constants.snowplowEvents.burgerMenuInsideClick
    : constants.snowplowEvents.burgerMenuLinkClick,
})

const addEvents = ({ nav, isLoggedIn }, isSubNav) => nav.map((item) => {
  const userLoggedIn = isLoggedIn ? 'yes' : 'no'

  const newItem = createEvent({ ...item, userLoggedIn }, isSubNav)

  if (Array.isArray(item.subNav)) {
    newItem.subNav = addEvents({ nav: item.subNav, isLoggedIn }, true)
  }

  return newItem
})

const getNav = createSelector(
  ({ globals }) => globals,
  ({ state }) => state.models.subscription,
  ({ state }) => state.models.me.isLoggedIn,
  ({ state }) => state.view.cosmeticsPage.structure,
  (globals, subscription, isLoggedIn, structure) => addEvents({
    nav: isLoggedIn ? getAuthNav({ structure, subscription, globals }) : getNoAuthNav({ globals }),
    isLoggedIn,
  })
)


export default getNav
